module.exports =
  home:
    base: '/'
    screenprint: '/screenprint'
    dtg: '/dtg'
    sublimation: '/sublimation'
    poster: '/posters'
    embroidery: '/embroidery'
    woocommerce: '/woocommerce'
    shopify: '/shopify'
    api: '/api'
    pricing: '/pricing'
    catalog: '/catalog'
    jobs: '/jobs'
    careers:
      base: '/careers'
      data:
        positions: '/careers/data/positions/'
    auth:
      register: '/auth/v2/register'
      login: '/auth/v2/login'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/website2.coffee